export default [
  {
    id: '9001',
    name: 'Basemap',
    url: 'https://sgx.geodatenzentrum.de/wms_basemapde',
    typ: 'WMS',
    format: 'image/png',
    version: '1.1.1',
    minScale: 0,
    maxScale: 1000000,
    transparent: true,
    layers: 'de_basemapde_web_raster_farbe',
    singleTile: false,
    tilesize: 256,
    legendURL:
      'https://sgx.geodatenzentrum.de/wms_basemapde?format=image%2Fpng&layer=de_basemapde_web_raster_farbe&sld_version=1.1.0&request=GetLegendGraphic&service=WMS&version=1.1.1&styles=',
  },
  {
    id: '9002',
    name: 'Basemap (Graustufen)',
    url: 'https://sgx.geodatenzentrum.de/wms_basemapde',
    typ: 'WMS',
    format: 'image/png',
    version: '1.1.1',
    minScale: 0,
    maxScale: 1000000,
    transparent: true,
    layers: 'de_basemapde_web_raster_grau',
    singleTile: false,
    tilesize: 256,
    legendURL:
      'https://sgx.geodatenzentrum.de/wms_basemapde?format=image%2Fpng&layer=de_basemapde_web_raster_grau&sld_version=1.1.0&request=GetLegendGraphic&service=WMS&version=1.1.1&styles=',
  },
  {
    id: '9003',
    name: 'Luftbilder',
    url: 'https://geoportale.dp.dsecurecloud.de/mapproxy/bgw/service',
    typ: 'WMS',
    format: 'image/png',
    version: '1.3.0',
    minScale: 0,
    maxScale: 1000000,
    legendURL: 'ignore',
    transparent: true,
    layers: 'DOP_20',
    singleTile: false,
    tilesize: 256,
  },
  {
    id: '14000',
    name: 'Verwaltungsgrenzen',
    url: 'https://dienste.gdi-sh.de/WMS_SH_ALKIS_Fluren_Gemarkungen',
    typ: 'WMS',
    format: 'image/png',
    version: '1.1.1',
    minScale: 0,
    maxScale: 1000000,
    legendURL: 'ignore',
    transparent: true,
    layers: 'Kreise_Aemter_Gemeinden',
    singleTile: false,
  },
  {
    id: '14001',
    name: 'ad:Address',
    url: 'https://umweltgeodienste.schleswig-holstein.de/WFS_BGW',
    typ: 'WFS',
    featureType: 'app:badestraende',
    version: '1.1.0',
    outputFormat: 'XML',
    layerAttribution: 'nicht vorhanden',
  },
  {
    id: '14002',
    name: 'ad:Address',
    url: 'https://umweltgeodienste.schleswig-holstein.de/WFS_BGW',
    typ: 'WFS',
    featureType: 'app:betrachtungsbereiche',
    version: '1.1.0',
    outputFormat: 'XML',
    layerAttribution: 'nicht vorhanden',
  },
  {
    id: '14003',
    name: 'ad:Address',
    url: 'https://umweltgeodienste.schleswig-holstein.de/WFS_BGW',
    typ: 'WFS',
    featureType: 'app:badestellen',
    version: '1.1.0',
    outputFormat: 'XML',
    layerAttribution: 'nicht vorhanden',
    clusterDistance: 20,
  },
  {
    id: '14004',
    name: 'ad:Address',
    url: 'https://umweltgeodienste.schleswig-holstein.de/WFS_BGW',
    typ: 'WFS',
    featureType: 'app:probenahmestellen',
    version: '1.1.0',
    outputFormat: 'XML',
    layerAttribution: 'nicht vorhanden',
  },
]
